import { __extends } from "tslib";
import { PartitionBase } from './PartitionBase';
/**
 * @class away.partition.Partition
 */
var BasicPartition = /** @class */ (function (_super) {
    __extends(BasicPartition, _super);
    function BasicPartition() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return BasicPartition;
}(PartitionBase));
export { BasicPartition };
